import { LanguageContext } from 'contexts/LanguageContext';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { useContext, useEffect } from 'react';
import { SystemContext } from '../contexts/legacy/SystemContext';

function Wootric({ bitrix24 }) {
	const { userLanguage } = useContext(LanguageContext);
	const { trial, subscriptionReady } = useContext(SystemContext);

	useEffect(() => {
		if (subscriptionReady && !trial) {
			function getUniqueKey() {
				let uniqueKey = bitrix24.user.EMAIL;
				const domain = bitrix24.domain;

				if (!uniqueKey) {
					uniqueKey = bitrix24.user.ID + '.' + domain;
				}

				return uniqueKey;
			}

			const setupScript = document.createElement('script');
			const uniqueKey = getUniqueKey();

			setupScript.type = 'text/javascript';
			setupScript.id = 'wootric-settings';
			setupScript.async = true;
			setupScript.innerHTML = `
			window.wootricSettings = {
				email: '${uniqueKey}',
				created_at: ${Math.round(+new Date() / 1000)},
				account_token: 'NPS-c32902ab',
				modal_position: 'top',
				properties:{
					domain: '${bitrix24.domain}',
					name: '${bitrix24.user.NAME} ${bitrix24.user.LAST_NAME}',
					role: '${bitrix24.user.WORK_POSITION}',
					language: '${userLanguage}'
				},
        scale_color: 'gradient'
			};
		`;

			if (document.getElementById('wootric-settings') == null) {
				document.body.appendChild(setupScript);
			}

			// Beacon
			const beacon = document.createElement('script');
			beacon.type = 'text/javascript';
			beacon.id = 'wootric-beacon';
			beacon.async = true;

			beacon.src = 'https://cdn.wootric.com/wootric-sdk.js';
			beacon.onload = function () {
				window.wootric('run');
			};
			if (document.getElementById('wootric-beacon') == null) {
				document.body.appendChild(beacon);
			}
		}
	}, [userLanguage, bitrix24, trial, subscriptionReady]);

	return <></>;
}

export default Bitrix24Consumer(Wootric);
